module.exports = __webpack_public_path__ + "static/img/ios6.8c15c725.jpg";